// extracted by mini-css-extract-plugin
module.exports = {"sunrise":"styles_sunrise__1GypV","sunset":"styles_sunset__6CMmI"};